module.exports = __webpack_public_path__ + "img/yw.95ac7edc.png";